import { render } from "./LoadingRipple.vue?vue&type=template&id=342a9120&scoped=true"
import script from "./LoadingRipple.vue?vue&type=script&lang=js"
export * from "./LoadingRipple.vue?vue&type=script&lang=js"

import "./LoadingRipple.vue?vue&type=style&index=0&id=342a9120&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-342a9120"]])

export default __exports__